import { RxJsonSchema } from 'rxdb';
import { AssetDetails } from './assetDetails.types';

export const assetDetailsSchema: RxJsonSchema<AssetDetails> = {
  type: 'object',
  version: 3,
  description: 'describes inspection lists',
  primaryKey: 'assetId',
  properties: {
    assetId: { type: 'string', maxLength: 36 },
    assetMainCategoryName: { type: ['string', 'null'] },
    assetName: { type: ['string', 'null'] },
    eAMAssetId: { type: ['number', 'null'] },
    eAMAssetName: { type: ['string', 'null'] },
    assetCategoryId: { type: ['number', 'null'] },
    assetCategoryName: { type: ['string', 'null'] },
    assetDescription: { type: ['string', 'null'] },
    installationDate: { type: ['string', 'null'] },
    namePcsId: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    comment: { type: ['string', 'null'] },
    site: { type: 'number' },
    discipline: { type: 'number' },
    assetDynamicProperty: {
      type: ['array', 'null'],
      items: {
        type: 'object',
        properties: {
          id: { type: ['number', 'null'] },
          assetPropertyDefinitionId: { type: ['number', 'null'] },
          assetPropertyValue: { type: ['string', 'null'] },
          assetPropertyDefinitionValue: { type: ['string', 'null'] },
          assetId: { type: ['number', 'null'] },
          name: { type: ['string', 'null'] },
          value: { type: ['string', 'null'] },
          dateCreated: { type: ['string', 'null'] },
          dateModified: { type: ['string', 'null'] },
        },
      },
    },
    assetFiles: {
      type: ['array', 'null'],
      items: {
        type: 'object',
        properties: {
          assetId: { type: ['number', 'null'] },
          fileId: { type: ['number', 'null'] },
          drawingType: { type: ['number', 'null'] },
          fileName: { type: ['string', 'null'] },
          value: { type: ['string', 'null'] },
          path: { type: ['string', 'null'] },
          site: { type: ['number', 'null'] },
          discipline: { type: ['number', 'null'] },
        },
      },
    },
    etapFields: {
      type: ['array', 'null'],
      items: {
        type: 'object',
        properties: {
          etapId: { type: ['number', 'null'] },
          assetId: { type: ['string'] },
          etapAssetId: { type: ['string', 'null'] },
          totalEnergy: { type: ['number', 'null'] },
          workingDistance: { type: ['string', 'null'] },
          afb: { type: ['string', 'null'] },
          kv: { type: ['string', 'null'] },
          site: { type: ['number', 'null'] },
          discipline: { type: ['number', 'null'] },
          inspectorId: { type: ['number', 'null'] },
          dateCreated: { type: ['string', 'null'] },
          dateModified: { type: ['string', 'null'] },
        },
      },
    },
    parentArea: { type: ['string', 'null'] },
    areaType: { type: ['string', 'null'] },
    floorLevel: { type: ['number', 'null'] },
    lowerBound: { type: ['string', 'null'] },
    upperBound: { type: ['string', 'null'] },
    temperature: { type: ['string', 'null'] },
    corrosion: { type: ['string', 'null'] },
    humidity: { type: ['string', 'null'] },
    waterMake: { type: ['string', 'null'] },
    floorMovement: { type: ['string', 'null'] },
    backMovement: { type: ['string', 'null'] },
    sideWallMovement: { type: ['string', 'null'] },
    aimsAssetID: { type: ['string', 'null'] },
    aimsAssetName: { type: ['string', 'null'] },
    eAMAreaId: { type: ['string', 'null'] },
  },
};
